<template>
  <div class="login-container">
    <div class="login-card">
      <img src="@/assets/mutuus-logo.svg" alt="Mutuus Logo" class="login-logo" />
      <h1>Solicitud de Enlace de Acceso</h1>
      <div class="login-form">
        <div class="form-group">
          <label for="email"
            >Por favor ingresa tu dirección de correo electrónico para solicitar un enlace de
            acceso.</label
          >
          <input
            id="email"
            v-model="email"
            type="email"
            placeholder="Ingresa tu correo electrónico"
            required
            class="form-input"
          />
        </div>
        <CustomButton
          text="Solicitar enlace de acceso"
          variant="secondary"
          :disabled="!email.trim()"
          @click="requestAccessLink"
        />
      </div>
    </div>
  </div>
  <ToastMessage
    v-model="showToast"
    :message="toastMessage"
    :submessage="toastSubmessage"
    :duration="10000"
    :type="toastType"
    :icon="toastIcon"
  />
</template>

<script setup lang="ts">
import { ref, inject } from 'vue'
import type { ApiService } from '@/services/apiService'
import { type ApiError } from '../types/errors'
import ToastMessage from '../components/ToastMessage.vue'
import checkIcon from '@/assets/check-icon.svg'
import errorIcon from '@/assets/error-icon-white.svg'
import CustomButton from '@/components/CustomButton.vue'

const apiService = inject<ApiService>('apiService')

const email = ref('')
const showToast = ref(false)
const toastMessage = ref('')
const toastSubmessage = ref('')
const toastType = ref<'success' | 'error'>('success')
const toastIcon = ref<string | undefined>(undefined)

const requestAccessLink = async () => {
  try {
    await apiService?.sendAccessLinkEmail(email.value)
    showToast.value = true
    toastMessage.value = 'Correo enviado'
    toastSubmessage.value = 'Se ha enviado el correo que contiene el link de acceso.'
    toastType.value = 'success'
    toastIcon.value = checkIcon
  } catch (error) {
    const apiError = error as ApiError
    const errorData = await apiError.response.json()
    toastMessage.value = 'Error'
    toastSubmessage.value = errorData.message
    toastType.value = 'error'
    toastIcon.value = errorIcon
    showToast.value = true
  }
}
</script>
<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #ffffff;
}

.login-card {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 10px 16px 0 rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-logo {
  width: 140px;
  margin-bottom: 1.5rem;
  display: block;
}

.login-card h1 {
  text-align: center;
  margin-bottom: 2rem;
  color: #333;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;
}

.login-button {
  padding: 0.75rem;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;
}

.login-button:hover:not(:disabled) {
  background-color: #0056b3;
}

.login-button:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.error-message {
  color: #dc3545;
  font-size: 0.875rem;
  text-align: center;
  padding: 0.5rem;
  background-color: #f8d7da;
  border: 1px solid #f5c6cb;
  border-radius: 4px;
}
</style>
